// The WhatsApp investing community is the front door to MarketNerve: the
// daily briefing, mentorship, resources and events all run out of it. Kept
// here rather than inline so the invite link and the member count are
// changed in one place (LandingPage, AboutUs, and anywhere else that links
// to the group).
export const COMMUNITY_URL = 'https://chat.whatsapp.com/D3YR7BSTKLoEb0GM8QNXPE';
export const COMMUNITY_SIZE = 300;
